import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteCompanyInvite } from 'api/company/deleteCompanyInvite'
import { companyDetailKey } from './keys'

export const useDeleteCompanyInviteMutation = (companyId: number) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (inviteId: number) =>
      deleteCompanyInvite({ companyId, inviteId }),
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: companyDetailKey(companyId) })
    },
  })
}
